import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { OAuthResourceServerErrorHandler, OAuthStorage } from 'angular-oauth2-oidc';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authStorage: OAuthStorage, private errorHandler: OAuthResourceServerErrorHandler, private logger: NGXLogger) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authStorage.getItem('access_token');
    if (token) {
      const header = 'Bearer ' + token;
      const headers = req.headers.set('Authorization', header);
      req = req.clone({ headers });
    } else {
      this.logger.error('OidcSecurityService undefined: NO auth header!');
    }

    return next.handle(req).pipe(catchError((err) => this.errorHandler.handleError(err)));
  }
}
